import React, { Component } from 'react';
import '../css/styleHome.css';
import { Col, Row } from 'reactstrap';
import HeaderComp from "../components/HeaderComp"
import fondo from "../imgs/KLBackground.png"
import NumPad from "../components/NumPad"
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { validarUsuario } from "../actions/index";

const mapStateToProps = state => {
  return { turnoRecibido: state.turnoRecibido };
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({ validarUsuario }, dispatch)
  };
};


class ModuloInicio extends Component {

  componentDidMount() {
    document.title = "DigiturnoKL - Módulo de Atención"
  }

  render() {
    return (
      <div>
        <div id="home">
          <div className="bg-img" style={{ backgroundImage: "url(" + fondo + ")" }}>
            <div className="overlay"></div>
          </div>
          <div className="home-wrapper">
            <div className="container">
              <Row>
                <Col xs="12">
                  <div className="home-content">
                    <HeaderComp></HeaderComp>
                    <NumPad></NumPad>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModuloInicio);
